<template>
    <div class="card-body">
        <div class="form">
            <div class="form-group">
                <label class="form-label" for="tipo-entrada">Tipo de entrada</label>
                <select class="form-control" aria-label="Tipo de entrada" v-model="manager.tipo_entrada">
                    <option value="personalizada">Personalizada</option>
                    <option value="generica">Genérica</option>
                </select>
            </div>
            <hr>
            <div class="form-group">
                <label class="form-label" for="tipo-entrada">Término "Entrada"</label>
                <input type="text" placeholder="Termino entrada" v-model="manager.termino_entrada">
            </div>
            <div class="form-group">
                <label class="form-label" for="tipo-entrada">Término "Entradas"</label>
                <input type="text" placeholder="Termino entradas" v-model="manager.termino_entradas">
            </div>
          <div class="row align-items-start">  
            <div class="form-group">
              <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" id="ocultar_iva_entradas" v-model="manager.ocultar_iva_entradas">
                <label class="custom-control-label" for="ocultar_iva_entradas">Ocultar IVA en las entradas</label>
              </div>
            </div>
            <div class="form-group ml-5">
              <label class="form_label">IVA AL {{ teatro.iva }}%</label>
            </div>
          </div>
            <Button @click="guardarOpciones">Guardar</Button>
        </div>
    </div>
</template>

<script>
export default {
    props: ['manager'],
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        },
        teatro() {
            return this.$store.getters.getTeatro;
        },
    },
    methods: {
        guardarOpciones() {
            this.$emit('guardar');
        }
    },
}
</script>
